module.exports = __webpack_public_path__ + "static/assets/71b4643a023fda17a8d251985914a201.png";